import React, { useState, useEffect, useRef } from "react"

import {
  Container,
  Row,
  Col,
  Table,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  Form,
  FormGroup,
  Label,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardHeader,
  Modal,
  Button,
} from "reactstrap"
import Select from "react-select"
import toast, { Toaster } from "react-hot-toast"
import ReactPaginate from "react-paginate"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import logo from "../../assets/images/hasini_logo_new_size.png"
import hasiniqrcode from "../../assets/images/hasiniqrcode.jpg"
import { useHistory, Link } from "react-router-dom"

//Import Images
import { saveAs } from "file-saver"

import { addData, updateData, deletedData, getAllData } from "Servicescalls"
import { imgUrl } from "Baseurls"
import { useReactToPrint } from "react-to-print"

const EcommerceCheckout = () => {
  const history = useHistory()
  const [modal_small, setmodal_small] = useState(false)
  const [modal_small2, setmodal_small2] = useState(false)
  const [btnshows, setbtnshows] = useState(false)

  function tog_small2() {
    setmodal_small2(!modal_small2)
  }
  const modalclose = () => {
    setmodal_small2(false)
    setproducts([])
    setform({
      name: "",
      phone: "",
      customvalue: false,
      posType: "pos",
      deliveryBoyId: "",
      address: "",
      deliveryDate: "",
      deliveryCharge: "",
    })
    setform2({ couponAmount: "" })
    setforminfo([])
  }

  const [activeTab, setactiveTab] = useState("1")

  const [selectedGroup, setselectedGroup] = useState("")

  const componentRef = useRef()
  const debounceRef = useRef(null)

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const printsecctions = () => {
    setTimeout(() => {
      handlePrint()
      setmodal_small2(false)
      setproducts([])
      setform({ name: "", phone: "", customvalue: false, deliveryBoyId: "", deliveryDate: "", deliveryCharge: "" })
      setform2({ couponAmount: "" })
      setforminfo([])
    }, 300)
  }

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const [products, setproducts] = useState([])
  const [products1, setproducts1] = useState([])
  const [ordercount, setordercount] = useState(1)

  // const subamount = products.reduce(function (prev, current, index) {
  //   return prev + +current.price * current.quantity[index]
  // }, 0)
  // console.log(subamount)

  const [boys, setboys] = useState([])

  const GetAllboys = async () => {
    const bodydata = {
      status: "active",
    }
    const resonse = await addData("deliveryBoy/list", bodydata)
    var _data = resonse
    setboys(_data.data.data)
  }

  const caramout = products.map(
    data => parseFloat(data.price) * parseFloat(data.quantity)
  )
  // console.log(caramout)

  const subamount = caramout.reduce((acc, value) => {
    if (!isNaN(value)) {
      return acc + value
    } else {
      return acc // Skip NaN values
    }
  }, 0)

  function removeCartItem(_id) {
    var filtered = products.filter(function (item) {
      return item._id !== _id
    })

    setproducts(filtered)
  }

  useEffect(() => {
    setordercount(products.map(product => 1))
  }, [products])

  const countUP = async (index, quantity) => {
    setexctra({
      cashPrice: "",
    })

    let myUser = [...products]
    myUser[index].quantity = parseFloat(quantity) + 1
    setproducts(myUser)
    const bodydata = {
      quantity: parseFloat(myUser[index].quantity),
    }
    try {
      const resonse = await addData(
        "stock/checkstockquantity/" + myUser[index]._id,
        bodydata
      )
      var _data = resonse
      // toast.success(_data.data.message)
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      } else {
        // toast.error("Please try again.")
      }
    }

    // }
  }

  const quantityChange = async (e, index) => {
    setexctra({
      cashPrice: "",
    })
    let myUser = [...products]
    myUser[index][e.target.name] = e.target.value
    setproducts(myUser)
    const bodydata = {
      quantity: e.target.value,
    }
    try {
      const resonse = await addData(
        "stock/checkstockquantity/" + myUser[index]._id,
        bodydata
      )
      var _data = resonse
      // toast.success(_data.data.message)
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
      } else {
        // toast.error("Please try again.")
        console.log("Please try again.")
      }
    }
  }

  const countDown = async (index, quantity) => {
    setexctra({
      cashPrice: "",
    })
    let myUser = [...products]
    myUser[index].quantity = Math.max(parseFloat(quantity) - 1, 1)
    setproducts(myUser)

    setordercount(prevCounts =>
      prevCounts.map((count, i) =>
        i === index ? Math.max(count - 1, 1) : count
      )
    )
  }

  const [category, setcategory] = useState([])
  const [category1, setcategory1] = useState([])
  const [subcategory, setsubcategory] = useState([])
  const [allProducts, setallProducts] = useState([])
  const [form, setform] = useState([])
  console.log(form)
  const [form1dis, setform1dis] = useState("")
  const [form2, setform2] = useState([])
  const [invoice, setinvoice] = useState([])
  const [monytypes, setmonytypes] = useState([])
  const [exctra, setexctra] = useState([])
  const [balnceamss, setbalnceamss] = useState([])
  const [totalamounts, settotalamounts] = useState([])

  const [sumtax, setsumtax] = useState(0)
  console.log(sumtax)
  const [sgstval, setsgstval] = useState(0)
  const [cgstval, setcgstval] = useState(0)

  useEffect(() => {
    const sgst = (parseFloat(subamount) * 2.5) / 100
    const cgst = (parseFloat(subamount) * 2.5) / 100
    setsgstval(sgst)
    setcgstval(cgst)
    setsumtax(sgst + cgst)

    const baseTotal = parseFloat(subamount) + parseFloat(sgst + cgst)
    const couponPercent = parseFloat(form2.couponAmount) || 0
    const discount = (baseTotal * couponPercent) / 100
    setform1dis(discount)
    
    // Add delivery charge for online orders
    const deliveryCharge = form?.posType === "online" ? (parseFloat(form?.deliveryCharge) || 0) : 0
    const totamount = baseTotal - discount + deliveryCharge

    settotalamounts(totamount.toFixed(2))
  }, [subamount, sumtax, sgstval, cgstval, form2.couponAmount, form?.deliveryCharge, form?.posType])

  // useEffect(() => {
  //   const totamount =
  //     parseFloat(subamount) +
  //     parseFloat(sumtax) -
  //     parseFloat(
  //       form2.couponAmount == "" || form2.couponAmount == undefined
  //         ? 0
  //         : form2.couponAmount
  //     )
  //   settotalamounts(parseFloat(totamount).toFixed(2))
  // }, [subamount, sumtax])

  const [listPerPage] = useState(12)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = subcategory.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(subcategory.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }

  const handleChange2 = e => {
    let myUser = { ...form2 }
    myUser[e.target.name] = e.target.value
    setform2(myUser)
    
    // Add delivery charge for online orders
    const deliveryCharge = form?.posType === "online" ? (parseFloat(form?.deliveryCharge) || 0) : 0
    const totalamount =
      parseFloat(subamount) +
      parseFloat(sumtax) -
      parseFloat(e.target.value == "" ? 0 : e.target.value) +
      deliveryCharge
    settotalamounts(parseFloat(totalamount).toFixed(2))
  }

  const handleChange000 = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }

  const handleChangeAmount = e => {
    let myUser = { ...monytypes }
    myUser[e.target.name] = e.target.value
    setmonytypes(myUser)
  }

  const handleChangeexctra = e => {
    let myUser = { ...exctra }
    myUser[e.target.name] = e.target.value
    setexctra(myUser)
    const balnceam = totalamounts - e.target.value
    setbalnceamss(parseFloat(balnceam).toFixed(2))
  }

  // get all function
  const getAllCategories = async () => {
    const resonse = await addData("category/getCategories")
    var _data = resonse
    setcategory(_data.data.categories)
    setcategory1(_data.data.categories[0])
    const bodydata = _data.data.categories[0]._id
    console.log(bodydata)
    const resonse1 = await getAllData("dish/getAlldish", {})
    var _data = resonse1
    setallProducts(_data.data.Dishes)
    const newlatestdata = _data.data.Dishes.filter(function (data) {
      return data.categories[0].value == bodydata
    })
    setsubcategory(newlatestdata)
  }

  const [activeCategory, setActiveCategory] = useState(null)

  const [subsearch, setsubsearch] = useState([])

  const getAllSubcategories = async data => {
    const bodydata = data._id
    const newlatestdata = allProducts.filter(function (data) {
      return data.categories[0].value == bodydata
    })
    setsubcategory(newlatestdata)
    setcategory1([])
    setActiveCategory(data)
    setsubsearch(data)
  }

  const [forminfo, setforminfo] = useState([])

  const findcustomers = async e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
    const bodydata = {
      phone: e.target.value,
    }
    const resonse = await addData("customer/getactivecutomers", bodydata)
    var _data = resonse
    setforminfo(_data?.data?.result[0])
  }

  const handleSearchChange = e => {
    const value = e.target.value

    // Clear previous timer
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }

    // Set new timer
    debounceRef.current = setTimeout(() => {
      getAllsearch(value)
    }, 500)
  }

  // get all search function
  const getAllsearch = async searchValue => {
    const bodydata = { categoryId: subsearch._id || category1._id }

    const response = await getAllData(
      "dish/getAlldish?searchQuery=" + searchValue,
      bodydata
    )

    setsubcategory(response.data.Dishes)
  }

  useEffect(() => {
    getAllCategories()
    GetAllboys()
  }, [])

  const getData = (data, key) => {
    console.log(data)
    setexctra({
      cashPrice: "",
    })

    setproducts(prevProducts => {
      console.log(prevProducts)
      const existingProductNames = prevProducts.map(value => value.name)
      if (existingProductNames.includes(data.name)) {
        toast.error("Product is already added")
        return prevProducts
      } else {
        var resdata = {
          _id: data._id,
          image: data.image,
          name: data.name,
          categories: data.categories[0].label,
          price: data.price,
          tax: data.tax,
          quantity: 1,
        }
        return [...prevProducts, resdata]
      }
    })
  }

  // Add products

  const addProducts = async e => {
    e.preventDefault()
    setbtnshows(true)
    const productData = products.map((data, index) => ({
      productId: data._id,
      name: data.name,
      quantity: data.quantity,
      tax: data.tax,
      amount: parseFloat(data.price).toFixed(2),
    }))

    const bodydata = {
      phone: form?.phone,
      name: form?.name,
      deliveryBoyId: form?.posType == "online" ? form?.deliveryBoyId : "",
      posType: form?.posType,
      address: form?.address,
      deliveryDate: form?.posType == "online" ? form?.deliveryDate : "",
      deliveryCharge: form?.posType == "online" ? (form?.deliveryCharge || 0) : 0,
      sgst: sgstval,
      cgst: cgstval,
      // customerId: selectedGroup.value || form1._id,
      subAmount: subamount,
      type: "pos",
      couponAmount: form2.length == 0 ? 0 : form1dis || 0,
      gst: parseFloat(sumtax),
      totalAmount:
        totalamounts.length == 0
          ? parseFloat(subamount + parseFloat(sumtax)).toFixed(2)
          : totalamounts,
      products: productData,
      PaymentMethod: monytypes.moneyType || "cash",
      cashPrice:
        monytypes.moneyType == "cash" ? subamount : exctra.cashPrice || 0,
      onlinePrice:
        monytypes.moneyType == "Card"
          ? subamount
          : balnceamss.length == 0
          ? 0
          : balnceamss,
    }
    try {
      const resonse = await addData("orders/create", bodydata)
      var _data = resonse
      console.log(_data)
      // toast.success(_data.data.message)
      setinvoice(_data?.data?.order)
      setproducts1(_data?.data?.order?.items)
      setmodal_small(false)
      sessionStorage.setItem("orderid", _data.data._id)
      // history.push("/invoice")
      setmodal_small2(true)
      setbtnshows(false)
      getAllCategories()
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(error.response.data.message)
        setbtnshows(false)
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Hasini Enterprises" breadcrumbItem="POS" />

          <div className="checkout-tabs">
            <Row>
              <Col md="8">
                <Row>
                  <Col md="2 p-1">
                    <Nav className="flex-column" pills>
                      {category.map((data, key) => (
                        <NavItem
                          key={key}
                          onClick={() => {
                            getAllSubcategories(data)
                          }}
                        >
                          <NavLink
                            className={`navcardshadow ${
                              activeCategory === data || category1 == data
                                ? "active"
                                : ""
                            }`}
                          >
                            <img
                              style={{
                                height: "50px",
                                width: "50px",
                                objectFit: "cover",
                              }}
                              src={imgUrl + data.image}
                            />
                            <p className="font-weight-bold">
                              {data.category_name}
                            </p>
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>
                  </Col>
                  <Col md="10">
                    <div className="mb-3">
                      <Row>
                        <Col md="6">
                          <Input
                            onChange={handleSearchChange}
                            type="text"
                            className="rounded-pill"
                            placeholder="Search..."
                          />
                        </Col>
                        <Col md="6"></Col>
                      </Row>
                    </div>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="1">
                        <div>
                          <Row
                            style={{
                              maxHeight: "700px",
                              overflowY: "auto",
                              overflowX: "hidden",
                            }}
                          >
                            {lists.length == 0 ? (
                              <Container>
                                <Card>
                                  <CardBody>
                                    <div className="text-center">
                                      <h5>No Data...</h5>
                                    </div>
                                  </CardBody>
                                </Card>
                              </Container>
                            ) : (
                              <>
                                {lists.slice(0, 12).map((data, key) => (
                                  <Col key={key} md="4">
                                    <Card>
                                      <div className="text-center ">
                                        <img
                                          className="rounded"
                                          src={imgUrl + data.image}
                                          style={{
                                            height: "150px",
                                            objectFit: "cover",
                                            width: "100%",
                                          }}
                                        />
                                      </div>{" "}
                                      <CardBody style={{ padding: "10px" }}>
                                        <h6 style={{ fontSize: "14px" }}>
                                          {data?.subCategory?.length > 15
                                            ? data.subCategory.substring(
                                                0,
                                                15
                                              ) + "..."
                                            : data.subCategory}
                                        </h6>
                                        <Row className="mt-2">
                                          <Col>
                                            {" "}
                                            <h6>
                                              {/* {data.name.length > 15
                                                ? data.name.substring(0, 15) +
                                                  "..."
                                                : data.name} */}

                                              {data.name}
                                            </h6>
                                            <h6>₹ {data.price}</h6>
                                          </Col>
                                          {/* <Col className="text-end">
                                            {" "}
                                            <h6 className="mt-2 text-muted">
                                              {data.quantity} items
                                            </h6>
                                          </Col> */}
                                          <Col className="mt-2" md="12">
                                            {data.quantity == "0" ? (
                                              <Button
                                                disabled
                                                className="btn-sm w-100"
                                                onClick={() => {
                                                  getData(data, key)
                                                }}
                                                style={{ width: "110px" }}
                                                color="danger"
                                              >
                                                Out of Stock
                                              </Button>
                                            ) : (
                                              <Button
                                                className="btn-sm w-100"
                                                onClick={() => {
                                                  getData(data, key)
                                                }}
                                                style={{ width: "100px" }}
                                                color="warning"
                                              >
                                                Add +
                                              </Button>
                                            )}
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </Col>
                                ))}
                                <div className="mt-3 d-flex justify-content-center align-items-center">
                                  <ReactPaginate
                                    previousLabel={"Previous"}
                                    nextLabel={"Next"}
                                    pageCount={pageCount}
                                    onPageChange={changePage}
                                    containerClassName={"pagination"}
                                    previousLinkClassName={"previousBttn"}
                                    nextLinkClassName={"nextBttn"}
                                    disabledClassName={"disabled"}
                                    activeClassName={"active"}
                                    total={lists.length}
                                  />
                                </div>
                              </>
                            )}
                          </Row>
                        </div>
                      </TabPane>
                    </TabContent>
                  </Col>
                </Row>
              </Col>

              {/* forms funciionalyt */}
              <Col md="4">
                <Card>
                  <CardBody>
                    <Form
                      onSubmit={e => {
                        addProducts(e)
                      }}
                    >
                      <div>
                        <CardTitle className="mb-2">Order Summary</CardTitle>
                        <Row className="mt-2 mt-1">
                          <b>Booking Type</b>
                          <Col md="6">
                            <div className="form-check">
                              <input
                                type="radio"
                                onChange={e => {
                                  handleChange000(e)
                                }}
                                id="pos"
                                defaultChecked
                                className="form-check-input"
                                value="pos"
                                name="posType"
                              />
                              <label className="form-check-label" htmlFor="pos">
                                Offline
                              </label>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="form-check">
                              <input
                                type="radio"
                                onChange={e => {
                                  handleChange000(e)
                                }}
                                id="online"
                                className="form-check-input"
                                value="online"
                                name="posType"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="online"
                              >
                                Online
                              </label>
                            </div>
                          </Col>
                        </Row>

                        <div>
                          <div>
                            <div className="mb-2 row">
                              <div style={{ padding: "1px" }} className="col-6">
                                <Input
                                  type="text"
                                  maxLength="10"
                                  pattern="[0-9]{10}"
                                  className="form-control"
                                  id="inlineFormInputGroupUsername"
                                  placeholder="Customer Mobile No"
                                  name="phone"
                                  value={form?.phone}
                                  onChange={e => {
                                    handleChange(e)
                                  }}
                                />
                              </div>
                              <div style={{ padding: "1px" }} className="col-6">
                                <Input
                                  type="text"
                                  pattern="^[a-zA-Z ]*$"
                                  className="form-control"
                                  id="basicpill-firstname-input1"
                                  placeholder="Enter Name"
                                  name="name"
                                  value={form?.name}
                                  onChange={e => {
                                    handleChange(e)
                                  }}
                                />
                              </div>
                              <div>
                                <a className="text-success">
                                  {forminfo?.name == undefined ? (
                                    ""
                                  ) : (
                                    <b>Customer Name: {forminfo?.name}</b>
                                  )}
                                </a>
                              </div>
                            </div>
                          </div>
                          {form?.posType == "online" ? (
                            <Col md="12">
                              <div className="mb-2">
                                <Label for="basicpill-firstname-input3">
                                  Assign Delivery Boy{" "}
                                  <span className="text-danger">*</span>
                                </Label>

                                <select
                                  value={form.deliveryBoyId}
                                  name="deliveryBoyId"
                                  required
                                  onChange={e => {
                                    handleChange(e)
                                  }}
                                  id="ss"
                                  className="form-select"
                                >
                                  <option value="">Select</option>
                                  {boys.map((data, index) => (
                                    <option key={index} value={data._id}>
                                      {data.firstname}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="mb-3">
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="addressde"
                                  placeholder="Enter Delivery Address"
                                  name="address"
                                  required
                                  value={form?.address}
                                  onChange={e => {
                                    handleChange(e)
                                  }}
                                />
                              </div>
                            <div className="mb-3">
                                <Label for="deliveryDate">
                                  Delivery Date <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="date"
                                  className="form-control"
                                  id="deliveryDate"
                                  name="deliveryDate"
                                  required
                                  value={form?.deliveryDate || ""}
                                  onChange={e => {
                                    handleChange(e)
                                  }}
                                />
                              </div>
                              <div className="mb-3">
                                <Label for="deliveryCharge">
                                  Delivery Charge <span className="text-danger">*</span>
                                </Label>
                                <Input
                                  type="number"
                                  className="form-control"
                                  id="deliveryCharge"
                                  name="deliveryCharge"
                                  placeholder="Enter Delivery Charge"
                                  min="0"
                                  step="0.01"
                                  required
                                  value={form?.deliveryCharge || ""}
                                  onChange={e => {
                                    handleChange(e)
                                  }}
                                />
                              </div>
                            </Col>
                          ) : (
                            ""
                          )}
                        </div>
                        <div
                          style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            overflowX: "hidden",
                          }}
                        >
                          <Table className="table align-middle mb-0 table-nowrap">
                            <tbody>
                              {products.map((product, index) => (
                                <tr key={product._id}>
                                  <td>
                                    <img
                                      src={imgUrl + product.image}
                                      alt="product-img"
                                      title="product-img"
                                      className="avatar-md"
                                    />
                                  </td>
                                  <td>
                                    <h5 className="font-size-14 text-truncate">
                                      {product.name.length > 10
                                        ? product.name.substring(0, 10) + "..."
                                        : product.name}
                                    </h5>
                                    <p className="mb-0">
                                      Price :{" "}
                                      <span className="fw-medium">
                                        ₹{" "}
                                        {parseFloat(
                                          product.price * product.quantity
                                        ).toFixed(2)}
                                      </span>
                                    </p>
                                    <div style={{ width: "120px" }}>
                                      <div className="input-group mt-2">
                                        <div className="input-group-append">
                                          <button
                                            type="button"
                                            className="btn-primary rounded-left"
                                            onClick={() =>
                                              countDown(index, product.quantity)
                                            }
                                          >
                                            -
                                          </button>
                                        </div>
                                        <Input
                                          style={{ height: "26px" }}
                                          className="text-center"
                                          type="number"
                                          // value={product.quantity}
                                          value={products[index].quantity}
                                          // value={ordercount[index]}
                                          name="quantity"
                                          onChange={e => {
                                            quantityChange(e, index)
                                          }}
                                        />
                                        <div className="input-group-prepend">
                                          <button
                                            type="button"
                                            className="btn-primary rounded-right"
                                            onClick={() =>
                                              countUP(index, product.quantity)
                                            }
                                          >
                                            +
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <Link
                                      to="#"
                                      onClick={() =>
                                        removeCartItem(product._id)
                                      }
                                      className="action-icon text-danger"
                                    >
                                      <i className="mdi mdi-trash-can font-size-18" />
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="table-responsive">
                        <Table className="table mb-0">
                          <tbody>
                            <tr>
                              <td>Subtotal:</td>
                              <td className="text-end">
                                ₹ {parseFloat(subamount).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td> SGST : </td>
                              <td className="text-end">₹ {sgstval}</td>
                            </tr>
                            <tr>
                              <td> CGST : </td>
                              <td className="text-end">₹ {cgstval}</td>
                            </tr>
                            <tr>
                              <td>Discount(%): </td>
                              <td>
                                <Input
                                  name="couponAmount"
                                  value={form2.couponAmount}
                                  onChange={e => {
                                    handleChange2(e)
                                  }}
                                  style={{ float: "right" }}
                                  size="sm"
                                  className="w-50"
                                  placeholder="Enter Discount"
                                  type="number"
                                />
                              </td>
                            </tr>
                            {form?.posType === "online" && (
                              <tr>
                                <td>Delivery Charge:</td>
                                <td className="text-end">
                                  ₹ {parseFloat(form?.deliveryCharge || 0).toFixed(2)}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <th>Total :</th>
                              <th className="text-end">₹ {totalamounts} </th>
                              {/* <th className="text-end">₹ {totalamounts.length == 0?(subamount + parseFloat(sumtax)):totalamounts} </th> */}
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                      <div>
                        <Row className="mt-3">
                          <Col md="6">
                            <div className="form-check">
                              <input
                                type="radio"
                                onChange={e => {
                                  handleChangeAmount(e)
                                }}
                                id="cash"
                                defaultChecked
                                className="form-check-input"
                                value="cash"
                                name="moneyType"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="cash"
                              >
                                Cash
                              </label>
                            </div>
                          </Col>
                          <Col md="6">
                            <div className="form-check">
                              <input
                                type="radio"
                                onChange={e => {
                                  handleChangeAmount(e)
                                }}
                                id="Online"
                                className="form-check-input"
                                value="online_payment"
                                name="moneyType"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="Online"
                              >
                                Online
                              </label>
                            </div>
                          </Col>
                          {/* <Col md="4">
                            <div className="form-check">
                              <input
                                type="radio"
                                onChange={e => {
                                  handleChangeAmount(e)
                                }}
                                id="Split"
                                className="form-check-input"
                                value="Split"
                                name="moneyType"
                              />
                              <label
                                className="form-check-label"
                                htmlFor="Split"
                              >
                                Split
                              </label>
                            </div>
                          </Col> */}
                        </Row>
                        {monytypes.moneyType == "Split" ? (
                          <Row className="mt-3">
                            <Col>
                              <Input
                                onChange={e => {
                                  handleChangeexctra(e)
                                }}
                                max={totalamounts}
                                value={exctra.cashPrice}
                                required
                                name="cashPrice"
                                type="number"
                                placeholder="Enter Cash Amount"
                              />
                            </Col>
                            <Col>
                              <Input
                                value={balnceamss}
                                disabled
                                name="onlinePrice"
                                type="number"
                                placeholder="Enter Online Amount"
                              />
                            </Col>
                          </Row>
                        ) : (
                          ""
                        )}
                        <Button
                          type="submit"
                          style={{ width: "100%" }}
                          color="success"
                          className="mt-3"
                          disabled={btnshows}
                        >
                          Submit <i className="bx bx-check-circle" />
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
        <Toaster />

        <Modal
          isOpen={modal_small2}
          toggle={() => {
            tog_small2()
          }}
        >
          <div className="modal-body">
            <div className="">
              <Button onClick={printsecctions} className="m-2" color="success">
                <i className="bx bx-printer"></i> Proceed If thermal printer is
                ready
              </Button>
              <Button
                onClick={() => {
                  modalclose()
                }}
                className="m-2"
                color="danger"
              >
                <i className="bx bx-left-arrow-alt"></i> Cancel
              </Button>
              <hr />
            </div>
            <Row>
              <Col md="2"></Col>
              <Col md="8">
                <div ref={componentRef}>
                  <div className="modal-body">
                    <div id="printableArea">
                      <div className="initial-38-1">
                        <div className="text-center mb-3">
                          <img src={logo} />
                        </div>
                        <div className="text-center">
                          <h5
                            style={{ fontSize: "12px" }}
                            className="text-break initial-38-4"
                          >
                            Name : {invoice.username}
                          </h5>
                          <h5
                            style={{ fontSize: "12px" }}
                            className="initial-38-4 initial-38-3"
                          >
                            Phone : {invoice.userPhone}
                          </h5>
                          {form?.posType === "online" && form?.deliveryDate && (
                            <h5
                              style={{ fontSize: "12px" }}
                              className="initial-38-4 initial-38-3"
                            >
                              Delivery Date : {form.deliveryDate}
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ borderBottom: "2px dashed #000" }}
                          className="initial-38-5"
                        ></div>
                        <div className="row mt-1">
                          <div className="col-5 pl-1 ml-1 pr-0 mr-0">
                            <h5 style={{ fontSize: "12px", fontWeight: "800" }}>
                              Invoice ID:
                              <span
                                style={{ marginBottom: "0px" }}
                                className="font-light"
                              >
                                {" "}
                                {invoice.bookingId}
                              </span>
                            </h5>
                          </div>
                          <div className="col-7 pl-1 ml-1 pr-0 mr-0">
                            <h5 style={{ fontSize: "12px", fontWeight: "800" }}>
                              <span className="font-light">
                                GST.No: 36ALXPB9886D2ZE
                                {/* {invoice?.updatedAt.slice(0, 10)} - {invoice?.updatedAt.slice(11, 15)} */}
                              </span>
                            </h5>
                          </div>
                          <div className="col-12"></div>
                        </div>
                        <h5
                          style={{ margin: "0px" }}
                          className="text-uppercase"
                        />
                        <span
                          style={{ borderBottom: "2px dashed #000" }}
                          className="initial-38-5"
                        ></span>
                        <table
                          style={{
                            fontSize: "10px",
                            marginBottom: "7px",
                            border: "2px solid black",
                          }}
                          className="table table-bordered"
                        >
                          <thead>
                            <tr>
                              <th
                                style={{ padding: "5px" }}
                                className="initial-38-6 border-top-0 border-bottom-0"
                              >
                                SNo
                              </th>
                              <th
                                style={{ padding: "5px" }}
                                className="initial-38-7 border-top-0 border-bottom-0"
                              >
                                Description
                              </th>
                              <th
                                style={{ padding: "5px" }}
                                className="initial-38-7 border-top-0 border-bottom-0"
                              >
                                Price
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {products1.map((data, key) => (
                              <tr key={key}>
                                <td style={{ padding: "5px" }}>{key + 1}</td>
                                <td style={{ padding: "5px" }}>
                                  <div>
                                    <h5 style={{ fontSize: "12px" }}>
                                      <b>
                                        {data.quantity} - {data.dishName}
                                      </b>
                                    </h5>
                                    {/* <b>Qty :</b> <span><b></b></span>
                                    <br />
                                    <b>Unit Price :</b>
                                    <span> <b>₹ {data.amount}</b></span>
                                    <br /> */}
                                  </div>
                                </td>
                                <td
                                  style={{ padding: "5px" }}
                                  className="w-28p"
                                >
                                  {" "}
                                  <b>₹ {data.amount * data.quantity}</b>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div className="px-3">
                          <dl
                            style={{ margin: "0px" }}
                            className="row text-right justify-content-center"
                          >
                            <dt style={{ margin: "0px" }} className="col-6">
                              Subtotal :
                            </dt>
                            <dd style={{ margin: "0px" }} className="col-6">
                              ₹ {invoice.subTotal}
                            </dd>

                            <dt style={{ margin: "0px" }} className="col-6">
                              SGST :
                            </dt>
                            <dd style={{ margin: "0px" }} className="col-6">
                              ₹
                              {invoice.sgst == undefined || invoice.sgst == null
                                ? 0
                                : invoice.sgst}
                            </dd>
                            <dt style={{ margin: "0px" }} className="col-6">
                              CGST :
                            </dt>

                            <dd style={{ margin: "0px" }} className="col-6">
                              ₹
                              {invoice.cgst == undefined || invoice.cgst == null
                                ? 0
                                : invoice.cgst}
                            </dd>
                            <dt style={{ margin: "0px" }} className="col-6">
                              Discount :
                            </dt>
                            <dd style={{ margin: "0px" }} className="col-6">
                              ₹{" "}
                              {invoice.couponAmount == "NaN"
                                ? 0
                                : invoice.discount}{" "}
                              <hr
                                style={{
                                  marginBottom: "5px",
                                  marginTop: "5px",
                                }}
                              />
                            </dd>
                            {form?.posType === "online" && form?.deliveryCharge && (
                              <>
                                <dt style={{ margin: "0px" }} className="col-6">
                                  Delivery Charge :
                                </dt>
                                <dd style={{ margin: "0px" }} className="col-6">
                                  ₹ {parseFloat(form.deliveryCharge).toFixed(2)}
                                </dd>
                              </>
                            )}

                            <dt className="col-6 font-20px">Total:</dt>
                            <dd className="col-6 font-20px">
                              ₹ {invoice.totalPrice}
                            </dd>
                            <dt className="col-6 font-20px">Money Type:</dt>
                            <dd className="col-6 font-20px">
                              {invoice.paymentMethod}
                            </dd>
                          </dl>

                          {/* <div className="text-center">
                            <img
                              src={hasiniqrcode}
                              style={{
                                height: "200px",
                                width: "200px",
                                padding: "10px",
                              }}
                            />
                          </div> */}

                          <div
                            style={{ borderBottom: "2px dashed #000" }}
                            className="initial-38-5"
                          ></div>
                          <h5
                            style={{ fontWeight: "800" }}
                            className="text-center"
                          >
                            <span className="d-block pt-2">
                              """THANK YOU"""
                            </span>
                          </h5>
                          <div
                            style={{ borderBottom: "2px dashed #000" }}
                            className="initial-38-5"
                          ></div>
                          <span className="d-block text-center text-mute pt-2">
                            Copyright @ Hasini Enterprises
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="2"></Col>
            </Row>
          </div>
        </Modal>
      </div>
    </React.Fragment>
  )
}

export default EcommerceCheckout
